module.exports = __webpack_public_path__ + "img/jije.802dc7ae.png";